<template>
    <v-snackbar
      :color="type"
      :bottom="verticalAlign === 'bottom'"
      :top="verticalAlign === 'top'"
      :left="horizontalAlign === 'left'"
      :right="horizontalAlign === 'right'"
      v-model="snackbar"
      :style="customPosition"
      @click="close()"
    >
      <v-icon
        color="white"
        class="mr-3"
      >
        {{ icon }}
      </v-icon>
      <div data-notify="message" v-html="message" />
      <v-icon
        size="16"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
</template>
<script>
export default {
  name: "notification",
  props: {
    message: String,
    icon: String,
    verticalAlign: {
      type: String,
      default: "bottom"
    },
    horizontalAlign: {
      type: String,
      default: "center"
    },
    type: {
      type: String,
      default: "info"
    },
    timeout: {
      type: Number,
      default: 2500
    },
    timestamp: {
      type: Date,
      default: () => new Date()
    }
  },
  data() {
    return {
    snackbar: true,
      elmHeight: 0
    };
  },
  computed: {
    customPosition() {
      let initialMargin = 20;
      let alertHeight = this.elmHeight + 10;
      let sameAlertsCount = this.$notifications.state.filter(alert => {
        return (
          alert.timestamp <= this.timestamp
        );
      }).length;
      let pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      let styles = {};
      if (this.verticalAlign === "top") {
        styles.top = `${pixels}px`;
      } else {
        styles.bottom = `${pixels}px`;
      }
      return styles;
    }
  },
  methods: {
    close() {
      this.$emit("on-close", this.timestamp);
    }
  },
  mounted() {
    this.elmHeight = this.$el.clientHeight;
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }
};
</script>